import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'simpleText'
})
export class SimpleTextPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    try{
      let html = decodeURIComponent(atob(value));
      let text = html.replace("<p>","").replace("</p>","").replace("<br>","").replace("</br>","");
      return text;
    }catch(e){
      let html = value;
      let text = html.replace("<p>","").replace("</p>","").replace("<br>","").replace("</br>","");
      return text;
    }finally{}
  }

}
